import "./App.css";
import { BrowserRouter } from "react-router-dom";
import Routers from "./routers/Router";
import { ToastContainer, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect, useState } from "react";
import axios from "axios";

function App() {
  const [, setNonce] = useState("");

  useEffect(() => {
    async function fetchNonce() {
      try {
        const response = await axios.get("/auth/nonce");

        // Lấy nonce từ header X-Nonce
        const fetchedNonce = response.headers["x-nonce"];

        if (fetchedNonce) {
          setNonce(fetchedNonce);
          window.nonce = fetchedNonce;

          // Gán nonce vào meta
          document
            .getElementById("nonce-meta")
            ?.setAttribute("data-nonce", fetchedNonce);

          // Cập nhật nonce cho các script/style đã có
          document.querySelectorAll("script, style").forEach((tag) => {
            if (!tag.hasAttribute("nonce")) {
              tag.setAttribute("nonce", fetchedNonce);
            }
          });
        }
      } catch (error) {
        console.error("Lỗi lấy nonce:", error);
      }
    }

    fetchNonce();
  }, []);

  return (
    <div className="App font-montserrat">
      <BrowserRouter>
        <Routers />

        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Bounce}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
